import React from "react";
import {
  IonButton,
  IonContent,
  IonPage,
  IonIcon,
} from "@ionic/react";
import {
  footballOutline,
  podiumOutline,
  trophyOutline,
} from "ionicons/icons";
import { useI18n } from "@/i18n";

const Landing: React.FC = () => {
  const { t } = useI18n();

  return (
    <IonPage>
      <IonContent fullscreen>
        {/* Hero */}
        <div className="hero-section">
          <h1>{t("appTitle")}</h1>
          <p>{t("landingWelcomeBody")}</p>
        </div>

        <div style={{ padding: "24px 16px" }}>
          {/* CTA buttons */}
          <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "32px" }}>
            <IonButton
              expand="block"
              routerLink="/login"
              routerDirection="forward"
              style={{ "--border-radius": "10px", fontWeight: 600 }}
            >
              {t("loginButton")}
            </IonButton>
            <IonButton
              expand="block"
              fill="outline"
              color="secondary"
              routerLink="/register"
              routerDirection="forward"
              style={{ "--border-radius": "10px", fontWeight: 600 }}
            >
              {t("registerCardTitle")}
            </IonButton>
          </div>

          {/* How it works */}
          <h3 style={{ margin: "0 0 16px 0", fontWeight: 700, fontSize: "17px" }}>
            {t("landingHowItWorks")}
          </h3>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
            <div className="how-tile">
              <IonIcon icon={footballOutline} />
              <strong>{t("landingHowItWorksItem1").split(".")[0]}</strong>
              <span>{t("landingHowItWorksItem1").includes(".") ? t("landingHowItWorksItem1").split(".").slice(1).join(".").trim() : ""}</span>
            </div>
            <div className="how-tile">
              <IonIcon icon={trophyOutline} />
              <strong>{t("landingHowItWorksItem2").split(".")[0]}</strong>
              <span>{t("landingHowItWorksItem2").includes(".") ? t("landingHowItWorksItem2").split(".").slice(1).join(".").trim() : ""}</span>
            </div>
            <div className="how-tile">
              <IonIcon icon={podiumOutline} />
              <strong>{t("landingHowItWorksItem3").split(".")[0]}</strong>
              <span>{t("landingHowItWorksItem3").includes(".") ? t("landingHowItWorksItem3").split(".").slice(1).join(".").trim() : ""}</span>
            </div>
          </div>
          <IonButton
            expand="block"
            fill="outline"
            routerLink="/how-it-works"
            routerDirection="forward"
            style={{ "--border-radius": "10px", fontWeight: 600, marginTop: "16px" }}
          >
            {t("howItWorksNav")}
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Landing;
